import { useState, useEffect } from "react";
import styles from "../styles/ImageSlider.module.css";

const ImageSlider = ({ images, autoSlide = true, slideInterval = 3000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Automatic sliding
    useEffect(() => {
        if (!autoSlide) return;
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, slideInterval);
        return () => clearInterval(interval);
    }, [images.length, autoSlide, slideInterval]);

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    return (
        <div className={styles.slider}>
            <button className={styles.prev} onClick={prevSlide}>
                &#10094;
            </button>
            <div className={styles.slideWrapper}>
                {images.map((image, index) => (
                    <img
                        key={index}
                        src={image}
                        alt={`slide-${index}`}
                        className={
                            index === currentIndex
                                ? `${styles.slide} ${styles.active}`
                                : styles.slide
                        }
                    />
                ))}
            </div>
            <button className={styles.next} onClick={nextSlide}>
                &#10095;
            </button>
            <div className={styles.dots}>
                {images.map((_, index) => (
                    <span
                        key={index}
                        className={
                            index === currentIndex ? `${styles.dot} ${styles.active}` : styles.dot
                        }
                        onClick={() => setCurrentIndex(index)}
                    ></span>
                ))}
            </div>
        </div>
    );
};

export default ImageSlider;